/* eslint-disable indent */
import firebase from 'firebase'

const firebaseConfig = {
    apiKey: 'AIzaSyA1_QLkdGe_kUciqt0XSvTn2btP9LWiPPI',
    authDomain: 'wizz-prod.firebaseapp.com',
    databaseURL: 'https://wizz-prod.firebaseio.com',
    projectId: 'wizz-prod',
    storageBucket: 'wizz-prod.appspot.com',
    messagingSenderId: '105827084097',
    appId: '1:105827084097:web:efacfda1c07c5e8b'
  }

const app = firebase.initializeApp(firebaseConfig)
const database = app.firestore()
const functions = firebase.functions()

var postDocument;

async function getPost (postID) {
    const postDocument = await database.collection('posts').doc(postID).get();
    return postDocument.exists ? postDocument.data() : null;
}

async function getPosts() {
    const postCollection = database.collection('posts')
    const postQuery = postCollection.where('country', '==', 'US').orderBy('creationDate', 'desc').limit(20)

    if (postDocument) {
        postQuery.startAfter(postDocument)
    }
    return postQuery.get()
}

async function reactToReaction(postReactionID, post, postID, snapUser) {
    const reactionID = `${postReactionID}_${postID}_${snapUser.userID}`
    const reaction = {
    owner: snapUser,
    reactionID: postReactionID,
    postID: postID,
    postOwnerID: post.owner.userID,
    creationDate: new Date().getTime()/1000,
    postLastUpdateDate: post.postLastUpdateDate
    };

    var reactToReaction =  functions.httpsCallable('reactToReaction');
    return reactToReaction({reaction: reaction, reactionID: reactionID});
}

async function sendComment(text, snapUser, post, postID) {
    const comment = {
    text: text,
    imageUrl: '',
    itemType: 'comment',
    link: '',
    imageWidth: 0,
    imageHeight: 0,
    owner: snapUser,
    index: post.commentCount + 1,
    compositeIndex: postID,
    creationDate: new Date().getTime()/1000
    }

    return database.collection('comments').doc().set(comment);
}

export {
    getPost, reactToReaction, sendComment, createSnapUser, getPosts
}



// WEBPACK FOOTER //
// ./src/scripts/firebase.js